import { faAsterisk } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useEffect, useRef, useState } from "react";
import { FloatingLabel, Form } from "react-bootstrap";
import { Tooltip } from "react-tooltip";

interface InputState {
  label: string;
  type: string;
  value: any;
  onUpdate: any;
  disabled?: any;
  required?: boolean;
  hasFocus?: boolean;
  labelAbove?: boolean;
  css?: string;
  showCharCount?: boolean;
  maxLength?: number;
}

const Input = ({
  label,
  type,
  value,
  onUpdate,
  disabled = false,
  required = false,
  hasFocus = false,
  labelAbove = false,
  css = "",
  showCharCount = false,
  maxLength,
}: InputState) => {
  const inputRef = useRef<HTMLInputElement>(null);

  useEffect(() => {
    if (hasFocus) {
      inputRef?.current?.focus();
    }
  }, [value, hasFocus]);

  const labelRef = useRef<HTMLLabelElement>(null);
  const [paddingTop, setPaddingTop] = useState("1.5rem");

  useEffect(() => {
    if (labelRef.current) {
      const labelHeight = labelRef.current.offsetHeight;
      // Adjust padding dynamically
      const dynamicPadding = Math.max(labelHeight + 12, 24); // 8px buffer
      setPaddingTop(`${dynamicPadding}px`);
    }
  }, [label]);

  const charCount = value ? value.length : 0;

  return (
    <>
      {required ? (
        <>
          {/* Cannot put label above for required fields */}
          <FloatingLabel
            data-tooltip-id="tooltip"
            data-tooltip-content="Required"
            controlId="floatingInput"
            label={label}
            className={css + " sm px-0"}
          >
            <Form.Control
              type={type}
              placeholder={label}
              value={value ? value : ""}
              onChange={onUpdate}
              disabled={disabled}
              ref={inputRef}
              maxLength={maxLength}
              style={{ paddingRight: showCharCount ? "4rem" : "undefined" }}
            />
            {showCharCount && (
              <span className="position-absolute bottom-0 end-0 pb-1 pe-2 small">{maxLength && `${charCount} / ${maxLength}`}</span>
            )}
            <FontAwesomeIcon
              className="app-tertiary-color-inverse"
              icon={faAsterisk}
              style={{ position: "absolute", right: 5, top: 5, fontSize: 11 }}
            />
          </FloatingLabel>
          <Tooltip id="tooltip" place="top" style={{ padding: "5px 10px", zIndex: "1100" }} />
        </>
      ) : (
        <>
          <FloatingLabel
            controlId="floatingInput"
            label={labelAbove ? <span ref={labelRef}>{label}</span> : label}
            className={css}
            style={labelAbove ? { paddingTop } : {}}
          >
            <Form.Control
              type={type}
              placeholder={label}
              value={value ? value : ""}
              onChange={onUpdate}
              disabled={disabled}
              ref={inputRef}
              maxLength={maxLength}
              style={{ paddingRight: showCharCount ? "4rem" : "undefined" }}
            />
            {showCharCount && (
              <span className="position-absolute bottom-0 end-0 pb-1 pe-2 small">{maxLength && `${charCount} / ${maxLength}`}</span>
            )}
          </FloatingLabel>
        </>
      )}
    </>
  );
};

export default Input;
